import { AcademyProgressSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Academy progress for the signed-in user (gap G19).
 *
 * `users/{uid}/academy/{trackId}` — self-readable and self-writable, narrowly
 * (firestore.rules pins the field set). Kept under the USER rather than the
 * tenant because learning belongs to the person: an owner who later opens a
 * second carwash has not forgotten how the queue board works.
 */
export function academyRepoFor(uid: string) {
  return createRepo({
    path: `users/${uid}/academy`,
    schema: AcademyProgressSchema,
    name: `users/${uid}/academy`,
  });
}
